import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/HolidayCalendar.css";

const HolidayCalendar = () => {
  const [holidays, setHolidays] = useState([]);

  const theme = localStorage.getItem("theme") || "simple";
  const isSimple = theme === "simple";
  const isDark = theme === "dark";
  const isColorful = theme === "colorful";

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        // Localhost in development, /api in production
        const API_URL = process.env.REACT_APP_API_URL || "";

        const response = await axios.get(
          `${API_URL}/api/HolidayCalendar`
        );

        setHolidays(response.data);
      } catch (error) {
        console.error("Error fetching holidays:", error);
      }
    };

    fetchHolidays();
  }, []);

  return (
    <div className={`holiday-calendar-container theme-${theme}`}>
      <h2>Holiday Calendar 2025</h2>

      <div className="holiday-grid">
        {holidays.map((holiday) => (
          <div key={holiday.id} className="holiday-card">
            <span className="holiday-icon">{holiday.icon}</span>

            <h4>{holiday.date}</h4>

            <p>{holiday.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HolidayCalendar;